import * as React from 'react'
import { HamburgerMenu } from '.'

/**
 * @interface MenuProps
 * @description Defines the properties for the AnimatedMenuIcon component.
 */
interface MenuProps {
	/** Current state of the menu */
	isMenuOpen: boolean
	/** Callback function triggered on click */
	toggleOpenMenu: () => void
}

const Menu: React.FC<MenuProps> = ({ isMenuOpen, toggleOpenMenu }) => {
	return (
		<div className="relative">
			<HamburgerMenu
				isOpen={ isMenuOpen }
				onToggle={ toggleOpenMenu }
			/>
		</div>
	)
}

export default Menu
